<script>
  import CompanyAwareMixin from '../base/CompanyAwareMixin.vue'
  import CreateView from '../base/CreateView.vue'
  import FormInput from '../form/form-input.vue'

  export default {
    components: {
      CreateView,
      FormInput,
    },
    mixins: [
      CompanyAwareMixin,
    ],
    data () {
      return {
        store: 'customer/create'
      }
    },
  }
</script>
<template>
  <create-view store="customer" update-route="CustomerUpdate" v-slot:default="slotProps" @reset="resetted">
    <form-input :store="slotProps.store" prop-name="addr1" class="col-3"></form-input>
    <form-input :store="slotProps.store" prop-name="addr2" class="col-3"></form-input>
    <form-input :store="slotProps.store" prop-name="addr3" class="col-3"></form-input>
    <form-input :store="slotProps.store" prop-name="addr4" class="col-3"></form-input>
    <form-input :store="slotProps.store" prop-name="email" class="col-3"></form-input>
    <form-input :store="slotProps.store" prop-name="vatId" class="col-3"></form-input>
  </create-view>
</template>

